<div class="tag-images">
    <div class="tag-images__inner">
        <ng-container *ngFor="let image of images; trackBy: trackBy">
            <div class="tag-images__item" *ngIf="image.hasSucceeded && image.data && image.data.ImageUrl"
                [title]="image.Name">
                <img directive-image-preload [url]="image.data.ImageUrl" class="tag-images__thumb" [alt]="image.Name"
                    width="20" height="20" />
            </div>
        </ng-container>
    </div>
</div>